import { isEqual, omit } from 'lodash';
import { VehicleCoverage } from 'Types/coverages/coverages.types';
import { getAppText } from 'Utils/text';
import {
  ChangeMotorcycleFormValues,
  CoverageConfig,
  CoverageOption,
} from './changeMotorcycleForm.types';
import {
  isAnsvarCoverage,
  isDelkaskoCoverage,
  isKaskoCoverage,
} from './helpers/changeMotorcycleForm.helpers';

export enum UsabilityCode {
  ALL_AGES = 'allAges',
  YOUNG_DRIVER = 'youngDriver',
  ADULT_DRIVER = 'adultDriver',
}

export const kaskoCoverageMotorcycle: CoverageOption = {
  id: 'kasko',
  label: 'Kasko',
  trackid: 'kasko',
  value: VehicleCoverage.FULL_OWN_DAMAGE,
};

export const delkaskoCoverageMotorcycle = (
  disabled: boolean,
): CoverageOption => {
  return {
    disabled,
    id: 'delkasko',
    label: 'Delkasko',
    trackid: 'delkasko',
    value: VehicleCoverage.REDUCED_OWN_DAMAGE,
    hint: getAppText(
      'changeInsurance.motorcycle.coverage.option.delkasko.hint',
    ),
  };
};

export const ansvarCoverageMotorcycle = (disabled: boolean): CoverageOption => {
  return {
    disabled,
    id: 'ansvar',
    label: 'Ansvar',
    trackid: 'ansvar',
    value: VehicleCoverage.DRIVER_AND_PASSENGER_ACCIDENT,
    hint: getAppText('changeInsurance.motorcycle.coverage.option.ansvar.hint'),
  };
};

export const COVERAGE_CONFIG = (
  initialValues: ChangeMotorcycleFormValues,
  values: ChangeMotorcycleFormValues,
): CoverageConfig => {
  const isNotEqualWithoutCoverageFields = !isEqual(
    omit(initialValues, 'coverage', 'coverageConfirmation', 'ownContribution'),
    omit(values, 'coverage', 'coverageConfirmation', 'ownContribution'),
  );

  const disableAnsvar =
    (isNotEqualWithoutCoverageFields &&
      !isAnsvarCoverage(initialValues.coverage)) ||
    (initialValues.hasMortgagee === true &&
      isKaskoCoverage(initialValues.coverage));

  const disabledDelkasko =
    (isNotEqualWithoutCoverageFields &&
      !isDelkaskoCoverage(initialValues.coverage) &&
      !isAnsvarCoverage(initialValues.coverage)) ||
    (initialValues.hasMortgagee === true &&
      isKaskoCoverage(initialValues.coverage));

  return {
    [VehicleCoverage.DRIVER_AND_PASSENGER_ACCIDENT]: {
      default: [
        kaskoCoverageMotorcycle,
        delkaskoCoverageMotorcycle(disabledDelkasko),
        ansvarCoverageMotorcycle(disableAnsvar),
      ],
      mortgagee: [ansvarCoverageMotorcycle(isNotEqualWithoutCoverageFields)],
    },
    [VehicleCoverage.REDUCED_OWN_DAMAGE]: {
      default: [
        kaskoCoverageMotorcycle,
        delkaskoCoverageMotorcycle(disabledDelkasko),
        ansvarCoverageMotorcycle(disableAnsvar),
      ],
      mortgagee: [delkaskoCoverageMotorcycle(isNotEqualWithoutCoverageFields)],
    },
    [VehicleCoverage.FULL_OWN_DAMAGE]: {
      default: [
        kaskoCoverageMotorcycle,
        delkaskoCoverageMotorcycle(disabledDelkasko),
        ansvarCoverageMotorcycle(disableAnsvar),
      ],
      mortgagee: [kaskoCoverageMotorcycle],
    },
  };
};
